import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GetCurrencySymbol } from '../../../../../../utils/Currency';
import { GetFloatNumber } from '../../../../../../utils/NumberFormatter';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function CustomerInvoiceTr({ item }) {
    const navigate = useNavigate();
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <Link
                    to={mkRelativeUrl(`/agency/${item?.agencyId}/customers/${item?.userId}/info`)}
                    className="flex flex-col gap-1 group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer"
                >
                    <span>{item?.organization}</span>
                    <span className="text-xs text-primary-500 truncate max-w-[200px]">
                        {item?.email}
                    </span>
                </Link>
            </td>
            <td>
                <Link
                    to={mkRelativeUrl(`/billing/invoices/${item?.id}/info`)}
                    className="flex flex-col gap-1 group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer"
                >
                    {item?.invoiceTitle}
                </Link>
            </td>

            <td className="text-center">
                <span>{GetDate(item?.timeIssue) || 'No Issue Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeDue) || 'No Due Date'}</span>
            </td>
            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amountBilled || 0)}
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amountPaid || 0)}
                </span>
            </td>

            <td className="text-center">
                <span className={item?.status === 'paid' ? 'text-success' : '!text-warning'}>
                    {TextCapitalize(item?.status) || '--'}
                </span>
            </td>

            <td>
                <span>
                    <button
                        type="button"
                        onClick={() =>
                            navigate(mkRelativeUrl(`/billing/invoices/${item?.id}/info`))
                        }
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Invoice"
                        className="size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function CustomerInvoiceTableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col" className="!text-left w-42">
                    <span>Customer Info</span>
                </th>
                <th scope="col">
                    <span>Title</span>
                </th>

                <th scope="col" className="w-30 text-center">
                    <span>Issue Date</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Due Date</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Currency</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Bill Amount</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Paid Amount</span>
                </th>
                <th scope="col" className="text-center w-30 !px-0">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}
function TableWeb({ data }) {
    return (
        <div className="agency_info_invoice_tab pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <CustomerInvoiceTableHeader />
                <tbody>
                    {data && data?.invoices?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Invoice Found!
                            </td>
                        </tr>
                    ) : (
                        data?.invoices?.map((item) => (
                            <CustomerInvoiceTr key={item.id} item={item} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
